
// import Nav from "./pages/Navbar";
// import Routess from "./Routes/Route";
// import { ColorModeScript } from '@chakra-ui/react';
// import theme from "./theme";
// import'./index.css'
import {
  BrowserRouter as Router,
  Route,
  Outlet,
  Routes
} from "react-router-dom";
import { useEffect ,useState,useLayoutEffect} from 'react';
import { useLocation } from 'react-router-dom';

import { socket } from './sockets/socket';
import Routess from './Routes/Route';
import { Input } from '@chakra-ui/react';
import DepositProvider from "./components/dashboard/Deposit/DepositProvider";
const ScrollToTop = () => {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes

}

function App() {
  

  // const [isConnected, setIsConnected] = useState(socket.connected);
  const [fooEvents, setFooEvents] = useState([]);
  const [roomId, setroomid] = useState([]);
  const [msgId, setmsgId] = useState([]);


//   useEffect(() => {
//     function onConnect() {
//       // setIsConnected(true);
//       console.log("connected")
//     }

//     function onDisconnect() {
//       setIsConnected(false);
//     }

//     function onFooEvent(value) {
//       setFooEvents(previous => [...previous, value]);
//     }
    
//     socket.on('connect', onConnect);
//     socket.on('disconnect', onDisconnect);
//     socket.on('foo', onFooEvent);
//     socket.on('receive', (value) => {
//       console.log(value);
//     }


   
//     )
//     return () => {
//       socket.off('connect', onConnect);
//       socket.off('disconnect', onDisconnect);
//       socket.off('foo', onFooEvent);
//     };
//   }, []);
// const joinroom=()=>{
//   socket.emit('joinroom',{roomid:roomId})
// }
// const messagess=()=>{
//   socket.emit('messages', {roomid:roomId,msgId:msgId});
  
// }
  return (
    <>

     <Routess />

{/* <input type="text" onChange={(e)=>setroomid(e.target.value)}  placeholder="Enter your message" />
<button onClick={joinroom}>Join Room</button>
<input type="text" onChange={(e)=>setmsgId(e.target.value)}  placeholder="Enter your message" />
<button onClick={messagess}>Send Message</button> */}
    </>
  );
}

export default App;
